import React from 'react'
import PageNotFound from '../components/404'

const NotFound = () => {
  return (
    <div className='contain-expand'>
        <PageNotFound />
    </div>
  )
}

export default NotFound